import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Select from "react-select";

// Filas de las matrices de Probabilidad / Impacto (radio 1..5, con color por nivel)
const PROBABILITY_ROWS = [
    { label: "Improbable",         value: 1, color: "#9a9a9a" },
    { label: "Remota",             value: 2, color: "#44b051" },
    { label: "Ocasional",          value: 3, color: "#ffc23b" },
    { label: "Probable",           value: 4, color: "#fa403c" },
    { label: "Altamente Probable", value: 5, color: "#7f1c1a" },
];
const IMPACT_ROWS = [
    { label: "Insignificante", value: 1, color: "#9a9a9a" },
    { label: "Baja gravedad",  value: 2, color: "#44b051" },
    { label: "Grave",          value: 3, color: "#ffc23b" },
    { label: "Muy Grave",      value: 4, color: "#fa403c" },
    { label: "Catastrófico",   value: 5, color: "#c02f2c" },
];
const AFFECTATION_ROWS = [
    { label: "Paciente",         value: "Paciente" },
    { label: "Personal Interno", value: "Personal de salud" },
    { label: "Empresa de Salud", value: "Empresa de Salud" },
    { label: "Externos",         value: "Externos" },
];

class FormCreateMejora extends Component {

    handleSubmit = e => { e.preventDefault(); };

    render() {
        const { formValues, errorValues } = this.props;
        const isError = errorValues === false;
        const probErr   = isError && formValues.probability == "";
        const impErr    = isError && formValues.impact == "";
        const affectErr = isError && formValues.possible_involvement_array.length == 0;

        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered modal-lg rk-modal"
                backdrop={this.props.backdrop}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-exclamation-triangle"></i></span>
                    <h5>{this.props.title}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <div className="rk-modal__body">
                        <div className="rk-field">
                            <label className="rk-label">Descripción del (Riesgo - Problema - Oportunidad)</label>
                            <textarea
                                name="description"
                                className={`rk-textarea ${isError && formValues.description == "" ? "rk-input--error" : ""}`}
                                value={formValues.description}
                                onChange={this.props.onChangeForm}
                                rows="4"
                            />
                        </div>

                        <div className="rk-field">
                            <label className="rk-label">Oportunidades <small className="validate-label">(opcional)</small></label>
                            <textarea
                                name="opportunities"
                                className="rk-textarea"
                                value={formValues.opportunities || ""}
                                onChange={this.props.onChangeForm}
                                rows="4"
                            />
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Clasificación del riesgo</label>
                                    <select
                                        name="risk_type"
                                        className={`rk-input ${isError && formValues.risk_type == "" ? "rk-input--error" : ""}`}
                                        value={formValues.risk_type}
                                        onChange={this.props.onChangeForm}
                                    >
                                        <option value="">Seleccione un tipo</option>
                                        <option value="Riesgo">Riesgo</option>
                                        <option value="Problema">Problema</option>
                                        <option value="Oportunidad">Oportunidad</option>
                                        {/* "Peligro" ya no se ofrece; solo aparece al editar un riesgo que lo tenga */}
                                        {formValues.risk_type == "Peligro" && <option value="Peligro">Peligro</option>}
                                    </select>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Cargo</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocompleteCriterios}
                                        options={this.props.criterios}
                                        autoFocus={false}
                                        classNamePrefix="select"
                                        placeholder="Seleccione"
                                        className={isError && formValues.criterio_id == "" ? "rk-input--error" : ""}
                                        value={this.props.selectedOptionCriterios}
                                    />
                                </div>
                            </div>
                        </div>

                        <hr className="rk-divider" />

                        {/* Matrices de valoración */}
                        <div className="rk-rmatrix-grid">
                            {/* Probabilidad */}
                            <div className="rk-rmatrix">
                                <div className={`rk-rmatrix__head ${probErr ? "rk-rmatrix__head--error" : ""}`}>
                                    {probErr ? "Seleccionar 1" : "Probabilidad"}
                                </div>
                                <table>
                                    <tbody>
                                        {PROBABILITY_ROWS.map(r => (
                                            <tr key={r.value}>
                                                <td className="rk-rmatrix__label" style={{ backgroundColor: r.color }}>{r.label}</td>
                                                <td className="rk-rmatrix__num">{r.value}</td>
                                                <td className="rk-rmatrix__input">
                                                    <input type="radio" name="probability" value={r.value}
                                                        checked={formValues.probability == r.value}
                                                        onChange={this.props.onChangeForm} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Impacto */}
                            <div className="rk-rmatrix">
                                <div className={`rk-rmatrix__head ${impErr ? "rk-rmatrix__head--error" : ""}`}>
                                    {impErr ? "Seleccionar 1" : "Impacto"}
                                </div>
                                <table>
                                    <tbody>
                                        {IMPACT_ROWS.map(r => (
                                            <tr key={r.value}>
                                                <td className="rk-rmatrix__label" style={{ backgroundColor: r.color }}>{r.label}</td>
                                                <td className="rk-rmatrix__num">{r.value}</td>
                                                <td className="rk-rmatrix__input">
                                                    <input type="radio" name="impact" value={r.value}
                                                        checked={formValues.impact == r.value}
                                                        onChange={this.props.onChangeForm} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Posible Afectación */}
                            <div className="rk-rmatrix">
                                <div className={`rk-rmatrix__head ${affectErr ? "rk-rmatrix__head--error" : "rk-rmatrix__head--accent"}`}>
                                    {affectErr ? "Seleccionar al menos 1" : "Posible Afectación"}
                                </div>
                                <table>
                                    <tbody>
                                        {AFFECTATION_ROWS.map(r => (
                                            <tr key={r.value}>
                                                <td className="rk-rmatrix__label" style={{ backgroundColor: "#02295f" }}>{r.label}</td>
                                                <td className="rk-rmatrix__input">
                                                    <input type="checkbox" name="probability" value={r.value}
                                                        checked={formValues.possible_involvement_array.includes(r.value)}
                                                        onChange={this.props.onChangeFormCheckbox} />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <hr className="rk-divider" />

                        <div className="row">
                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Actividad de riesgo</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocompleteActivities}
                                        options={this.props.activities}
                                        autoFocus={false}
                                        classNamePrefix="select"
                                        placeholder="Seleccione"
                                        className={isError && formValues.risk_activity_id == "" ? "rk-input--error" : ""}
                                        value={this.props.selectedOptionActivities}
                                    />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="rk-field">
                                    <label className="rk-label">Área específica</label>
                                    <Select
                                        onChange={this.props.handleChangeAutocompleteSpecificAreas}
                                        options={this.props.specificAreas}
                                        autoFocus={false}
                                        classNamePrefix="select"
                                        placeholder="Seleccione"
                                        className={isError && formValues.specific_area_id == "" ? "rk-input--error" : ""}
                                        value={this.props.selectedOptionSpecificAreas}
                                    />
                                </div>
                            </div>
                        </div>

                        {isError && (
                            <div className="rk-alert">
                                <i className="fas fa-exclamation-circle"></i>
                                Debes completar todos los campos requeridos
                            </div>
                        )}
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                            Cerrar
                        </button>
                        <button type="button" className="rk-btn rk-btn--primary" onClick={this.props.submitForm}>
                            <i className="fas fa-check"></i> {this.props.nameSubmit}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default FormCreateMejora;
